import styled from "styled-components";

export const EstudiosGloabl = styled.section`
  width: 100px;
  transform: rotate(-90deg);
  font-size: 18px;
  color: black;
  text-align: center;
  @media (max-width: 992px) {
    display: none;
  }
`;
